module.exports = __webpack_public_path__ + "02_short_brown.718adb04.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/02_short_brown.png
// module id = 7pl0
// module chunks = 0